<template>

  <el-dialog
    title="Добавление нового пуша"
    :visible="visible"
    :before-close="close"
    @opened="onOpen"
  >
    <el-form ref="addForm" :rules="addFormRules" :model="addForm" v-loading="loading">
      <el-form-item label="Заголовок" prop="surname" :error="errors.surname | errorToSrt">
        <el-input name="surname" ref="autoFocus" placeholder="Введите данные в поле"
                  v-model="addForm.surname"></el-input>
      </el-form-item>
      <el-form-item label="Тело" prop="name" :error="errors.name | errorToSrt">
        <el-input name="name" placeholder="Введите данные в поле" v-model="addForm.name"></el-input>
      </el-form-item>

      <el-form-item label="Приоритет" prop="gender_id" :error="errors.gender_id | errorToSrt">
        <el-input-number class="dialog__number" v-model="addForm.priory" :min="1" :max="10"></el-input-number>
      </el-form-item>

      <el-form-item label="builder" prop="gender_id" :error="errors.gender_id | errorToSrt">
        <el-select
          class="dialog__select"
          v-model="addForm.gender_id"
          placeholder="Выберите значение"
        >
          <el-option
            v-for="gender in genderList"
            :key="gender.id"
            :label="gender.title"
            :value="gender.id"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="type" prop="type" :error="errors.gender_id | errorToSrt">
        <el-select
          class="dialog__select"
          v-model="addForm.type"
          placeholder="Выберите значение"
        >
          <el-option
            v-for="gender in genderList"
            :key="gender.id"
            :label="gender.title"
            :value="gender.id"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="user_group" prop="user_group" :error="errors.user_group | errorToSrt">
        <el-select
          class="dialog__select"
          v-model="addForm.type"
          placeholder="Выберите значение"
        >
          <el-option
            v-for="gender in genderList"
            :key="gender.id"
            :label="gender.title"
            :value="gender.id"
          ></el-option>
        </el-select>
      </el-form-item>

      <!--      <el-form-item label="Роль сотрудника" prop="type">-->
      <!--        <el-select v-model="addForm.type" class="dialog__select">-->
      <!--          <el-option value="20" label="Ассистент" />-->
      <!--          <el-option value="40" label="Врач" />-->
      <!--          <el-option value="60" label="Администратор" />-->
      <!--        </el-select>-->
      <!--      </el-form-item>-->

    </el-form>

    <span slot="footer" class="dialog-footer">
        <el-button
          name="create"
          type="default"
          :loading="loadAddForm"
          @click="saveForm(false)"
        >Сохранить и создать еще</el-button>
        <el-button
          type="primary"
          :loading="loadAddForm"
          @click="saveForm(true)"
        >Сохранить и закрыть</el-button>
      </span>
  </el-dialog>
</template>

<script>
import Vue from 'vue'
import VueMask from 'v-mask'

Vue.use(VueMask)

export default {
  name: 'DialogWorkerAdd',
  data () {
    return {
      form: null,
      error: null,
      loadAddForm: !!0,
      genderList: null,
      loading: !!1,
      errors: {},
      addForm: {
        type: '20'
      },
      addFormRules: {
        surname: [
          {
            required: true,
            message: 'Заполните поле',
            trigger: 'blur'
          }
        ],
        name: [
          {
            required: true,
            message: 'Заполните поле',
            trigger: 'blur'
          }
        ],
        birthday: [
          {
            required: true,
            message: 'Заполните поле',
            trigger: 'blur'
          }
        ],
        password: [
          {
            required: true,
            message: 'Заполните поле',
            trigger: 'blur'
          }
        ],
        phone: [
          {
            required: false,
            message: 'Заполните поле',
            trigger: ['blur', 'change']
          }
        ],
        email: [
          {
            required: true,
            message: 'Заполните поле',
            trigger: 'blur'
          },
          {
            type: 'email',
            message: 'Укажите валидный e-mail',
            trigger: ['blur', 'change']
          }
        ],
        gender_id: [
          {
            required: true,
            message: 'Укажите пол',
            trigger: 'blur'
          }
        ],
        type: [{
          required: true,
          message: 'Выберите роль',
          trigger: 'blur'
        }]
      }
    }
  },

  filters: {
    errorToSrt (t) {
      return t ? t.join(', ') : null
    }
  },
  props: {
    visible: {
      required: true
    }
  },
  methods: {
    onOpen () {
      this.loadLogic()
    },
    close () {
      this.$emit('close')
    },
    loadLogic () {
      this.addForm = {
        type: '20'
      }
      this.autoFocus()

      this.loading = true
      this.$api.question
        .getCompendium('gender')
        .then((response) => {
          this.genderList = response.data.data
        })
        .catch(() => {
          this.$notify.error({
            title: 'Упс...',
            message: 'Ошибка всязи'
          })
        }).finally(() => {
          this.loading = !!0
        })
    },
    generatePassword () {
      Vue.set(this.addForm, 'password', Math.random().toString(36).slice(-8))
      this.$refs.password.passwordVisible = !!1
    },
    autoFocus () {
      this.$refs.autoFocus.focus()
    },
    saveForm (close) {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.errors = {}
          this.loadAddForm = !!1
          const payLoad = { ...this.addForm, ...{} }
          payLoad.phone = payLoad.phone ? payLoad.phone.replace(/[^\d]/g, '') : ''

          this.$api.doctor
            .create(payLoad)
            .then((response) => {
              this.$notify.success({
                title: 'Успешно',
                message: 'Данные сохранены'
              })

              if (close) {
                this.$emit('update')
                this.$emit('close')
              } else {
                this.$emit('update')
                this.addForm = {
                  type: '20'
                }
                this.autoFocus()
              }
            })
            .catch((response) => {
              const attribute = response.response.data.attribute
              if (attribute) {
                this.errors = attribute
              }

              this.$notify.error({
                title: 'Ошибка',
                message: response.response.data.message ? response.response.data.message : 'Проверьте правильность полей'
              })
            })
            .finally(() => {
              this.loadAddForm = !!0
            })
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">

.dialog {
  &__description {
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 19px;

    color: #aaaeba;
    margin: 25px 0 40px 0;

    &_mini {
      font-size: 14px;
    }
  }

  &__select {
    margin: 10px 0;
    width: 100%;
  }
  &__number {
    margin: 10px 0;
    width: 100%;
  }

  &__date {
    margin: 10px 0;
    width: 100%;
  }

  &__btns {
    float: right;
  }
}

</style>
